import { useState } from "react";
import Sidebar from "@/components/feature/Sidebar";
import TopBar from "@/components/feature/TopBar";
import GenelBakis from "./components/GenelBakis";
import ZiyaretciAkisi from "./components/ZiyaretciAkisi";
import KampanyaAnalizi from "./components/KampanyaAnalizi";
import Basvurular from "./components/Basvurular";
import WhatsappHareketleri from "./components/WhatsappHareketleri";
import PopupPerformansi from "./components/PopupPerformansi";
import Ayarlar from "./components/Ayarlar";
import ReklamOlustur from "./components/ReklamOlustur";

const menuBasliklar: Record<string, { baslik: string; altBaslik: string }> = {
  "genel-bakis": { baslik: "Genel Bakış", altBaslik: "Platform performans özeti" },
  "ziyaretci-akisi": { baslik: "Ziyaretçi Akışı", altBaslik: "Adım adım kullanıcı hareketleri" },
  "kampanya-analizi": { baslik: "Kampanya Analizi", altBaslik: "Kampanya performans karşılaştırması" },
  "basvurular": { baslik: "Başvurular", altBaslik: "Lead listesi ve kullanıcı detayları" },
  "whatsapp-hareketleri": { baslik: "WhatsApp Hareketleri", altBaslik: "Direkt iletişim takibi" },
  "popup-performansi": { baslik: "Teklif / Popup Performansı", altBaslik: "Popup gösterim ve dönüşüm analizi" },
  "reklam-olustur": { baslik: "Reklam Oluştur", altBaslik: "Adım adım rehberli reklam oluşturma" },
  "ayarlar": { baslik: "Ayarlar", altBaslik: "Panel tercihleri" },
};

export default function HomePage() {
  const [aktifMenu, setAktifMenu] = useState("genel-bakis");
  const [mobileSidebarAcik, setMobileSidebarAcik] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const renderIcerik = () => {
    switch (aktifMenu) {
      case "genel-bakis": return <GenelBakis />;
      case "ziyaretci-akisi": return <ZiyaretciAkisi />;
      case "kampanya-analizi": return <KampanyaAnalizi />;
      case "basvurular": return <Basvurular />;
      case "whatsapp-hareketleri": return <WhatsappHareketleri />;
      case "popup-performansi": return <PopupPerformansi />;
      case "reklam-olustur": return <ReklamOlustur />;
      case "ayarlar": return <Ayarlar />;
      default: return <GenelBakis />;
    }
  };

  const { baslik, altBaslik } = menuBasliklar[aktifMenu] || menuBasliklar["genel-bakis"];

  return (
    <div className="min-h-screen font-sans" style={{ backgroundColor: "#0d0f16" }}>
      <Sidebar
        aktifMenu={aktifMenu}
        onMenuChange={setAktifMenu}
        mobileAcik={mobileSidebarAcik}
        onMobileKapat={() => setMobileSidebarAcik(false)}
      />
      <TopBar
        baslik={baslik}
        altBaslik={altBaslik}
        onHamburgerClick={() => setMobileSidebarAcik(true)}
        sidebarCollapsed={sidebarCollapsed}
      />
      {/* Main content - mobilde full width, desktop'ta sidebar kadar offset */}
      <main
        className={`transition-all duration-300 pt-16 min-h-screen
          lg:pl-64 ${sidebarCollapsed ? "lg:pl-16" : "lg:pl-64"}
        `}
      >
        <div className="p-4 md:p-6">
          <div key={aktifMenu} className="animate-fadeIn">
            {renderIcerik()}
          </div>
        </div>
      </main>
    </div>
  );
}
